import { IAgenciesAttributes } from 'shared/interfaces/IRepresentatives';
import { Typography } from '@material-ui/core';
import {
  AddRepresentativesFormListAgencyRenderOptionContainer,
  AddRepresentativesFormListAgencyRenderOptionDetailsContainer,
  AddRepresentativesFormListAgencyRenderOptionAvatar,
} from './AddRepresentativesFormListAgencyRenderOption.styles.';

type AddRepresentativesAgencyRenderListProps = {
  option: IAgenciesAttributes;
};

const AddRepresentativesFormListAgencyRenderOption = ({ option }: AddRepresentativesAgencyRenderListProps) => {
  return (
    <AddRepresentativesFormListAgencyRenderOptionContainer>
      <AddRepresentativesFormListAgencyRenderOptionAvatar title={(option?.full_name || option?.name || '')[0] || 'A'} />
      <AddRepresentativesFormListAgencyRenderOptionDetailsContainer>
        <Typography style={{ fontSize: 14, fontWeight: 500 }}>{option?.full_name || option?.name}</Typography>
        <Typography
          style={{ fontSize: 12 }}
        >{`${option?.full_name && option?.name ? option?.name + ' ' + '-' : ''} ${option?.type || 'Agency'}`}</Typography>
      </AddRepresentativesFormListAgencyRenderOptionDetailsContainer>
    </AddRepresentativesFormListAgencyRenderOptionContainer>
  );
};

export default AddRepresentativesFormListAgencyRenderOption;
